import { Api } from "../../api";
import { pickPagesStaticRowForDomain } from "../../utils/pagesStaticDomain";

export const fetchMeta = (Redis, host, page, reset = false) => {
  return async (dispatch) => {
    const buildMetaFromPagesStaticRow = (pagesStaticRow) => {
      const pagesStaticData = pagesStaticRow?.data || {};
      return {
        TITLE: pagesStaticData.metaTitle,
        H1: pagesStaticData.h1,
        DESCRIPTION: pagesStaticData.metaDescription,
        CONTENT: pagesStaticData.content,
      };
    };

    let data = {};
    try {
      // Один запрос: все записи этого url (своя на домен и общая root),
      // подходящую выбираем по хосту.
      const pagesStaticRows = await Api.databaseContent.getMeta(
        Redis,
        reset,
        page,
      );
      const pagesStaticRow = pickPagesStaticRowForDomain(
        pagesStaticRows || [],
        host,
        page,
      );
      if (pagesStaticRow) data = buildMetaFromPagesStaticRow(pagesStaticRow);
    } catch (e) {
      console.error(e);
      data = {};
    }
    if (data.TITLE) {
      dispatch({ type: "SET_TITLE", payload: data.TITLE });
    }
    if (data.H1) {
      dispatch({ type: "SET_H1", payload: data.H1 });
    }
    if (data.DESCRIPTION) {
      dispatch({ type: "SET_DESCRIPTION", payload: data.DESCRIPTION });
    }
    if (data.CONTENT) {
      dispatch({ type: "SET_CONTENT", payload: data.CONTENT });
    }
  };
};

export const fetchMetaBaltex = (Redis, page, reset = false) => {
  return async (dispatch) => {
    const data = (await Api.baltex.getMeta(Redis, page, reset)) || {};
    if (data.TITLE) {
      dispatch({ type: "SET_TITLE", payload: data.TITLE });
    }
    if (data.H1) {
      dispatch({ type: "SET_H1", payload: data.H1 });
    }
    if (data.DESCRIPTION) {
      dispatch({ type: "SET_DESCRIPTION", payload: data.DESCRIPTION });
    }
    if (data.CONTENT) {
      dispatch({ type: "SET_CONTENT", payload: data.CONTENT });
    }
  };
};

export const fetchMetaLendings = (Redis, host, page, reset = false) => {
  return async (dispatch) => {
    const data = (await Api.lendings.getMeta(Redis, host, page, reset)) || {};
    if (data.TITLE) {
      dispatch({ type: "SET_TITLE", payload: data.TITLE });
    }
    if (data.H1) {
      dispatch({ type: "SET_H1", payload: data.H1 });
    }
    if (data.DESCRIPTION) {
      dispatch({ type: "SET_DESCRIPTION", payload: data.DESCRIPTION });
    }
    if (data.CONTENT) {
      dispatch({ type: "SET_CONTENT", payload: data.CONTENT });
    }
  };
};

export const setTitle = (title) => {
  return async (dispatch) => {
    dispatch({ type: "SET_TITLE", payload: title });
  };
};

export const setDescription = (description) => {
  return async (dispatch) => {
    dispatch({ type: "SET_DESCRIPTION", payload: description });
  };
};

/**
 * Диспатчит мету из уже загруженных данных (TITLE, H1, DESCRIPTION, CONTENT).
 * Для использования когда данные получены снаружи (например, с кешем).
 */
export const setMetaFromData = (data) => {
  return (dispatch) => {
    const meta = data || {};
    if (meta.TITLE) dispatch({ type: "SET_TITLE", payload: meta.TITLE });
    if (meta.H1) dispatch({ type: "SET_H1", payload: meta.H1 });
    if (meta.DESCRIPTION)
      dispatch({ type: "SET_DESCRIPTION", payload: meta.DESCRIPTION });
    if (meta.CONTENT) dispatch({ type: "SET_CONTENT", payload: meta.CONTENT });
  };
};

/** Поля SEO с SSR — отдельный экшен на каждую сущность */

export const setMetaCanonicalFromSsr = (canonicalLinks) => ({
  type: "SET_META_CANONICAL",
  payload: canonicalLinks,
});

export const setMetaOpenGraphTagsFromSsr = (openGraphTags) => ({
  type: "SET_META_OPEN_GRAPH_TAGS",
  payload: openGraphTags,
});

/** Ссылки перелинковки для текущей страницы (панель «SEO → Перелинковка») */
export const setInternalLinksFromSsr = (links) => ({
  type: "SET_META_INTERNAL_LINKS",
  payload: Array.isArray(links) ? links : [],
});

/** Готовые строки для <script type="application/ld+json"> с SSR */
export const setMetaJsonLdScriptsFromSsr = (jsonLdScripts) => ({
  type: "SET_META_JSON_LD_SCRIPTS",
  payload: Array.isArray(jsonLdScripts)
    ? jsonLdScripts.filter((s) => typeof s === "string" && s)
    : [],
});
